import { useTranslation } from 'react-i18next'

import { Anchor, CardDashboard, IllustratedMessage, Loader, Timeline } from '@percent/lemonade'
import { AgentVerificationTimelineProps } from './AgentVerificationTimeline.types'
import { useAgentVerificationTimeline } from './useAgentVerificationTimeline'

export function AgentVerificationTimeline({ logs, isLoadingAgentVerificationLogs }: AgentVerificationTimelineProps) {
  const { t } = useTranslation()

  const timeline = useAgentVerificationTimeline(logs)?.map(
    ({ reusedAgentVerificationId, description, ...timelineElement }) => ({
      ...timelineElement,
      description: reusedAgentVerificationId ? (
        <>
          {t('typography.agentVerificationTimeline.reusedAgentVerification')}{' '}
          <Anchor
            inherit
            c="inherit"
            underline="always"
            href={`/agent-verification/${reusedAgentVerificationId}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            {reusedAgentVerificationId}
          </Anchor>
        </>
      ) : (
        description
      )
    })
  )

  if (isLoadingAgentVerificationLogs) return <Loader />

  if (!timeline) {
    return (
      <CardDashboard data-testid="agent-verification-empty-timeline">
        <IllustratedMessage illustration="no-results" description={t('typography.noActivity')} />
      </CardDashboard>
    )
  }

  return (
    <CardDashboard title={t('typography.allActivity')} data-testid="agent-verification-timeline">
      <Timeline timeline={timeline} />
    </CardDashboard>
  )
}
